import Typesense from "typesense";
import { config } from "@/lib/config.ts";
export const typesense = new Typesense.Client({
  nodes: [
    {
      host: config.typesense.host,
      port: config.typesense.port || 443,
      protocol: "https",
    },
  ],
  apiKey: config.typesense.apiKey,
  connectionTimeoutSeconds: 2,
});
